import axios from 'axios';
//import Cookies from 'js-cookie';
// const [token,setToken]=useState(null);

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const logout = () => {
 // setToken(null);
  localStorage.removeItem('token');
  localStorage.removeItem("adminInfo");
  localStorage.removeItem("authTime")
};
// let i=0;
const redirectToLogin = async () => {
  try {
    const response = await axios.post( `${process.env.REACT_APP_API_BASE_URL}/login`, {
      "username":"Admin Panel",
      "password":"Admin@123",
    });
    const token = response.data.key;
   //setToken(token);
 localStorage.setItem('token', token);
  } catch (error) {
    console.error('Login failed:', error.message);
  }
};

const handleTokenExpiration = () => {
  logout();
  redirectToLogin();
};
instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
    if (!token) {
      redirectToLogin();
    }
  return {
    ...config,
    headers: {
      authorization: token ? `Bearer ${token}` : null,
    },
  };
});
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleTokenExpiration();
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body) => instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url, body) => instance.delete(url, body).then(responseBody),
};

export default requests;
